<template>
	<div
		class="font-squad shadow-label-opaque h-5.5 rounded-full bg-linear-to-b p-px transition-colors duration-500"
		:class="{
			'from-[#FEC84B] to-[#FDB022] text-[#7A2E0E]': active,
			'text-label-tertiary from-[#4F4F4F] to-[#3F3F3F]': !active
		}"
	>
		<div
			class="flex h-full items-center rounded-full px-1.5 transition-colors duration-500"
			:class="{
				'bg-[#FDB022]': active,
				'bg-[#3F3F3F]': !active
			}"
		>
			<div class="h-fit text-xs font-black whitespace-nowrap uppercase">
				{{ value }}
			</div>
		</div>
	</div>
</template>
<script setup lang="ts">
defineProps<{
	value: string
	active?: boolean
}>()
</script>
